import RioTimePicker from '@rio-cloud/rio-uikit/TimePicker';

import { FormGroup } from './FormGroup.tsx';
import { ValidationViolation } from './ValidationViolation.tsx';

type TimePickerProps = {
    className?: string;
    value?: string;
    name: string;
    error?: string | string[];
    onChange?: (value: string) => void;
    label?: string;
};

export const TimePicker = ({ name, value, className, onChange, error, label }: TimePickerProps) => (
    <FormGroup className={className} hasViolation={!!error}>
        <label htmlFor={name}>{label}</label>
        <RioTimePicker
            value={value ?? ''}
            onChange={onChange}
            showIcon={true}
            dropdown={true}
            inputProps={{
                id: name,
                name,
                autoComplete: 'off',
                'aria-label': label,
            }}
        />
        <ValidationViolation violations={error} />
    </FormGroup>
);
